// src/components/modal/modal-layout.ts
import type { ViewStyle } from 'react-native';
import { modalTokens } from './modal-tokens';

interface SurfaceArgs {
  maxWidth?: number;
  /** value applied to the surface backgroundColor */
  background: string;
}

/**
 * The modal surface style: a centered, fully-rounded card on BOTH web and
 * mobile. Mobile intentionally does NOT use a bottom sheet — a bottom sheet
 * covered the tab bar/menu. Screen margins and safe-area are applied by the
 * AppModal backdrop, so this stays platform-agnostic.
 */
export function getModalSurfaceStyle({ maxWidth, background }: SurfaceArgs): ViewStyle {
  return {
    width: '100%',
    maxWidth: maxWidth ?? modalTokens.webMaxWidth,
    maxHeight: modalTokens.surfaceMaxHeight,
    borderRadius: modalTokens.radius,
    backgroundColor: background,
    overflow: 'hidden',
  };
}
